import MyError from '../components/MyError/MyError';

const NotFound = () => <MyError />;

export default NotFound;
